<ng-container>
    <div class="button-container">
        <button mat-icon-button aria-label="close dialog" mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div>
        <img
            mat-card-avatar
            src="{{
                provider.logoPath
                    ? provider.logoPath
                    : 'https://placeholder.pics/svg/300/DEDEDE/FFFFFF-FFFFFF'
            }}"
            [alt]="provider.name"
        />
    </div>
    <div>
        <mat-card-header>
            <a
                [href]="provider.webSite"
                target="_blank"
                rel="noopener"
                class="{{
                    provider.webSite ? 'title-link' : ''
                }} site-title truncate float-right"
            >
                {{ provider.name }}
                @if (provider.webSite) {
                <mat-icon style="font-size: inherit; text-decoration: inherit"
                    >open_in_new</mat-icon
                >
                }
            </a>
        </mat-card-header>
    </div>

    <div class="layout">
        <div class="welcome">
            <div class="allsite">All Sites</div>
            @for (site of sites; track site) {
            <div class="site-link">
                <a
                    class="ancor-color truncate"
                    href="https://maps.google.com/?q={{
                        site.streetAddress +
                            ', ' +
                            site.city +
                            ', ' +
                            site.postalCode +
                            ', ' +
                            site.stateCode
                    }}"
                    target="_blank"
                    rel="noopener"
                >
                    {{
                        site.streetAddress +
                            ", " +
                            site.city +
                            ", " +
                            site.postalCode +
                            ", " +
                            site.stateCode
                    }}
                </a>
            </div>
            }
        </div>
    </div>
</ng-container>
